// extracted by mini-css-extract-plugin
export default {"title":"Card_title__eXUut","content":"Card_content__1RASj","contentText":"Card_contentText__oBKsK"};